import { CardDetailFragment } from 'generated/resources/graphql'

interface AmplitudeContextData {
  context?: string
  previousStatus?: string
  action?: string
  origin?: string
  cancellationReason?: string
  amount?: number
  interval?: string
  categories?: string[]
}

export const cardAmplitudeData = (resource: CardDetailFragment, data: AmplitudeContextData) => {
  const {
    context = '',
    previousStatus = '',
    action = '',
    origin = '',
    cancellationReason = '',
  } = data

  return {
    card_id: resource.id,
    card_type: resource.type,
    previous_status: previousStatus,
    current_status: resource.status,
    context: context,
    action: action,
    origin: origin,
    cancellation_reason: cancellationReason,
    spending_limit_amount: resource.cardLimit.limitForCurrentPeriod,
    spending_limit_interval: resource.cardLimit.period,
    spending_limit_merchant_categories: resource.cardLimit.categories,
  }
}
